import { Link } from 'react-router-dom';

export default function HowItWorksSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            How OOPBuy Spreadsheet Works
          </h2>
          <p className="text-base text-foreground-500 max-w-[600px] mx-auto">
            A step-by-step breakdown of the <strong>spreadsheet shopping system</strong> workflow
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((step, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/50 hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5">
                <span className="font-heading text-lg font-bold">{step.num}</span>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const steps = [
  {
    num: '01',
    title: 'Browse Structured Spreadsheets',
    desc: 'Navigate through well-organized product spreadsheets that categorize items with detailed information including pricing, supplier data, and product specifications.',
  },
  {
    num: '02',
    title: 'Analyze Product Data',
    desc: 'Review comprehensive product details — price comparisons, supplier reliability metrics, and item specifications — all presented in an easy-to-scan format.',
  },
  {
    num: '03',
    title: 'Compare Multiple Listings',
    desc: 'View several product options simultaneously within a single interface, making it easy to weigh pros and cons and identify the best value.',
  },
  {
    num: '04',
    title: 'Select Preferred Items',
    desc: 'Mark your favorite picks and shortlist the products that best match your requirements, budget, and quality expectations.',
  },
  {
    num: '05',
    title: 'Follow Guided Purchase Process',
    desc: 'Proceed through a clear, structured checkout pathway that guides you from selection to order confirmation with full transparency.',
  },
  {
    num: '06',
    title: 'Track Order Status',
    desc: 'Monitor your order progress within the system, staying updated on shipping, delivery estimates, and any status changes throughout the process.',
  },
];